import { render } from "./DispatchList.vue?vue&type=template&id=4e2a1746"
import script from "./DispatchList.vue?vue&type=script&lang=js"
export * from "./DispatchList.vue?vue&type=script&lang=js"

import "./DispatchList.vue?vue&type=style&index=0&id=4e2a1746&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__